import { React, useState } from "react";
import { Paper, Button, Box, Typography, Grid } from "@mui/material";
import FeedbackIcon from "../../Svg/FeedbackIcon";
import FingerTouchIcon from "../../Svg/FingerTouchIcon";
import QuestionMarkIcon from "../../Svg/QuestionMarkIcon";
import WheelIcon from "../../Svg/WheelIcon";
import ApiWheelIcon from "../../Svg/ApiWheelIcon";
import { BackIcon } from "../../Svg";

const Support = () => {
  const [pagenumber, SetPageNumber] = useState(1);

  return (
    <>
      {/* First Page of The Support Page */}
      {pagenumber === 1 && (
        <Box sx={{ marginTop: "50px" }}>
          <Typography
            variant="h4"
            sx={{ display: "flex", justifyContent: "center", style: "normal" }}
          >
            Support
          </Typography>
          <Typography
            variant="p"
            sx={{
              display: "flex",
              justifyContent: "center",
              color: "gray",
              fontStyle: "Inter",
              style: "normal",
            }}
          >
            You need? Kindly select any option and you'll get right away
          </Typography>
          <Box sx={{ flexGrow: 1 }} marginTop={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "280px",
                    paddingTop: "20px",
                    boxShadow: "0",
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <WheelIcon />
                  </Box>
                  <h3
                    style={{
                      textAlign: "center",
                      fontStyle: "Inter",
                      style: "normal",
                    }}
                  >
                    Setup Guide
                  </h3>
                  <p style={{ textAlign: "center" }}>Learn how to integrate </p>
                  <p style={{ textAlign: "center" }}>
                    LimosPay with your bussiness
                  </p>
                  <Box sx={{ textAlign: "center" }}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        SetPageNumber(2);
                      }}
                      sx={{ fontWeight: "bold" }}
                    >
                      Show Me
                    </Button>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "280px",
                    paddingTop: "20px",
                    boxShadow: "0",
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <ApiWheelIcon />
                  </Box>
                  <h3
                    style={{
                      textAlign: "center",
                      fontStyle: "Inter",
                      style: "normal",
                    }}
                  >
                    API Documentation
                  </h3>
                  <p style={{ textAlign: "center" }}>
                    Learn how to build amazing
                  </p>
                  <p style={{ textAlign: "center" }}>
                    things with the LimosPay API
                  </p>
                  <Box sx={{ textAlign: "center" }}>
                    <Button variant="outlined" sx={{ fontWeight: "bold" }}>
                      View Doc
                    </Button>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "280px",
                    paddingTop: "20px",
                    boxShadow: "0",
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <FingerTouchIcon />
                  </Box>
                  <h3
                    style={{
                      textAlign: "center",
                      fontStyle: "Inter",
                      style: "normal",
                    }}
                  >
                    Dashboard Icon
                  </h3>
                  <p style={{ textAlign: "center" }}>
                    Learn about the features of the
                  </p>
                  <p style={{ textAlign: "center" }}>LimosPay Dashboard</p>
                  <Box sx={{ textAlign: "center" }}>
                    <Button variant="outlined" sx={{ fontWeight: "bold" }}>
                      Explore
                    </Button>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "280px",
                    paddingTop: "20px",
                    boxShadow: "0",
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <QuestionMarkIcon />
                  </Box>
                  <h3
                    style={{
                      textAlign: "center",
                      fontStyle: "Inter",
                      style: "normal",
                    }}
                  >
                    FAQs
                  </h3>
                  <p style={{ textAlign: "center" }}>
                    Get quick answers to any
                  </p>
                  <p style={{ textAlign: "center" }}>
                    questions about LimosPay
                  </p>
                  <Box sx={{ textAlign: "center" }}>
                    <Button variant="outlined" sx={{ fontWeight: "bold" }}>
                      Find Answers
                    </Button>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "280px",
                    paddingTop: "20px",
                    boxShadow: "0",
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <FeedbackIcon />
                  </Box>
                  <h3
                    style={{
                      textAlign: "center",
                      fontStyle: "Inter",
                      style: "normal",
                    }}
                  >
                    Share Your Feedback
                  </h3>
                  <p style={{ textAlign: "center" }}>
                    If you spot something that can
                  </p>
                  <p style={{ textAlign: "center" }}>be better, let us know</p>
                  <Box sx={{ textAlign: "center" }}>
                    <Button variant="outlined" sx={{ fontWeight: "bold" }}>
                      Share
                    </Button>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "280px",
                    paddingTop: "20px",
                    boxShadow: "0",
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <QuestionMarkIcon />
                  </Box>
                  <h3
                    style={{
                      textAlign: "center",
                      fontStyle: "Inter",
                      style: "normal",
                    }}
                  >
                    Get in Touch
                  </h3>
                  <p style={{ textAlign: "center" }}>Send us a message when</p>
                  <p style={{ textAlign: "center" }}>someone is available</p>
                  <Box sx={{ textAlign: "center" }}>
                    <Button variant="outlined" sx={{ fontWeight: "bold" }}>
                      Contact Us
                    </Button>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
      {/* 2nd Page (To Setup Guide) */}
      {pagenumber === 2 && (
        <Box marginTop={7}>
          <Box>
            <Button
              onClick={() => {
                SetPageNumber(1);
              }}
              variant="none"
            //  sx={{boxShadow:"0"}}
            sx={{backgroundColor:"#eaedf2"}}
            >
              <BackIcon />
              <b> Back</b>
            </Button>
          </Box>
          {/* <Box sx={{display:"flex", textAlign:"center"}}> */}
          <Typography
            sx={{ display: "flex", justifyContent: "center" }}
            variant="h5"
          >
            Setup Guide
          </Typography>
          <Typography
            sx={{ display: "flex", justifyContent: "center" }}
            color="gray"
            variant="p"
          >
            You need? Kindly Select any option and you'll get right away
          </Typography>
          {/* </Box> */}
          <Paper
            sx={{
              marginTop: "10px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6">
              Learn How to Integrate LimosPay with Your Bussiness
            </Typography>
          </Paper>
          <Paper
            sx={{
              marginTop: "10px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6">
              Learn How to Integrate LimosPay with Your Bussiness
            </Typography>
          </Paper>
          <Paper
            sx={{
              marginTop: "10px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6">
              Learn How to Integrate LimosPay with Your Bussiness
            </Typography>
          </Paper>
          <Paper
            sx={{
              marginTop: "10px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6">
              Learn How to Integrate LimosPay with Your Bussiness
            </Typography>
          </Paper>
          <Paper
            sx={{
              marginTop: "10px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6">
              Learn How to Integrate LimosPay with Your Bussiness
            </Typography>
          </Paper>
        </Box>
      )}{" "}
    </>
  );
};

export default Support;
